import React, { useEffect, useState } from 'react';
import { useGame } from '../context/GameContext';
import Cell from './Cell';
import { GRID_SIZE, CELL_SIZE, GRID_GAP } from '../constants/gameConstants';
import '../styles/Board.css';

const Board = () => {
  const { board } = useGame();
  const [boardSize, setBoardSize] = useState(0);
  const [cellSize, setCellSize] = useState(CELL_SIZE);
  const [gridGap, setGridGap] = useState(GRID_GAP);

  useEffect(() => {
    const updateSize = () => {
      const container = document.querySelector('.game-container');
      if (!container) return;

      const width = container.clientWidth;
      const padding = 16; // 1rem padding
      const availableWidth = width - (padding * 2);

      // Calculate responsive sizes
      const newBoardSize = Math.min(availableWidth, 500);
      const newCellSize = (newBoardSize - (GRID_GAP * (GRID_SIZE + 1))) / GRID_SIZE;

      setBoardSize(newBoardSize);
      setCellSize(newCellSize);

      // Adjust grid gap for smaller screens
      if (width < 350) {
        setGridGap(8);
      } else {
        setGridGap(GRID_GAP);
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <div
      className="board-container"
      style={{
        width: `${boardSize}px`,
        height: `${boardSize}px`,
        gap: `${gridGap}px`,
        padding: `${gridGap}px`
      }}
    >
      {/* Background cells */}
      {Array.from({ length: GRID_SIZE * GRID_SIZE }).map((_, index) => (
        <div
          key={`bg-${index}`}
          className="cell background-cell"
          style={{
            width: `${cellSize}px`,
            height: `${cellSize}px`
          }}
        />
      ))}

      {/* Tile cells */}
      {board.map((row, rowIndex) =>
        row.map((cell, colIndex) =>
            cell && (
              <Cell
                key={cell.id}
                value={cell.value}
                row={rowIndex}
                col={colIndex}
                isNew={cell.isNew}
                merged={cell.merged}
                cellSize={cellSize}
                gridGap={gridGap}
              />
            )
        )
      )}
    </div>
  );
};

export default Board;